import "./ColorSwatch.scss";

export default {
  props: {
    color: String,
    name: String,
    checked: {
      type: Boolean,
      default: false,
    },
    func: {
      type: Function,
      default: () => {},
    },
  },
};
